import { DateTime } from 'luxon';

import { CampaignName, LabOrganization, PartnerOrganization } from '../API';
import { DEFAULT_TIMEZONE_PT } from '../constants';
import { Dollar, makeDollar } from '../currency';
import {
  CampaignAgeCategory,
  CampaignGroupName,
  CampaignType,
  PatientPopulation,
} from '../types/campaigns/types';

// TODO(renita): consolidate the lead screening campaigns & series into the adult Medicaid ones.
// We want to be able to handle the lead screening patients based on their referral services, which would
// also simplify bulk upload (no need to splice the lists).
export enum CampaignSeries {
  AETNA_ILLINOIS_MEDICAID_INITIAL_ENGAGEMENT = 'AETNA_ILLINOIS_MEDICAID_INITIAL_ENGAGEMENT',
  AETNA_ILLINOIS_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT = 'AETNA_ILLINOIS_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT',
  ALIGNMENTSTARS_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT = 'ALIGNMENTSTARS_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT',

  CENTENE_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT = 'CENTENE_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT',
  CENTENE_MISSISSIPPI_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_MISSISSIPPI_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_CONNECTICUT_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_CONNECTICUT_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_FLORIDA_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_FLORIDA_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_GEORGIA_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_GEORGIA_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_INDIANA_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_INDIANA_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_KENTUCKY_MEDICAID_INITIAL_ENGAGEMENT = 'CENTENE_KENTUCKY_MEDICAID_INITIAL_ENGAGEMENT',
  CENTENE_KENTUCKY_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT = 'CENTENE_KENTUCKY_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT',
  CENTENE_KENTUCKY_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_KENTUCKY_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_MAINE_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_MAINE_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_MASSACHUSETTS_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_MASSACHUSETTS_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_MICHIGAN_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_MICHIGAN_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT = 'CENTENE_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT',
  CENTENE_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_NEWHAMPSHIRE_EXCHANGE_INITIAL_ENGAGEMENT = 'CENTENE_NEWHAMPSHIRE_EXCHANGE_INITIAL_ENGAGEMENT',
  CENTENE_NEWHAMPSHIRE_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_NEWHAMPSHIRE_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_OHIO_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_OHIO_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_OHIO_EXCHANGE_INITIAL_ENGAGEMENT = 'CENTENE_OHIO_EXCHANGE_INITIAL_ENGAGEMENT',
  CENTENE_OHIO_MEDICAID_INITIAL_ENGAGEMENT = 'CENTENE_OHIO_MEDICAID_INITIAL_ENGAGEMENT',
  CENTENE_OHIO_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_OHIO_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_TEXAS_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_TEXAS_MEDICARE_INITIAL_ENGAGEMENT',
  CENTENE_TEXAS_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT = 'CENTENE_TEXAS_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT',

  CENTRALCALIFORNIAALLIANCEFORHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT = 'CENTRALCALIFORNIAALLIANCEFORHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT',
  CENTRALCALIFORNIAALLIANCEFORHEALTH_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT = 'CENTRALCALIFORNIAALLIANCEFORHEALTH_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT',

  ELEVANCEHEALTH_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT = 'ELEVANCEHEALTH_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT',

  HUMANA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT = 'HUMANA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT',
  HUMANA_NEWYORK_MEDICARE_INITIAL_ENGAGEMENT = 'HUMANA_NEWYORK_MEDICARE_INITIAL_ENGAGEMENT',
  HUMANA_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT = 'HUMANA_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT',

  MOLINA_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT = 'MOLINA_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT',
  MOLINA_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT = 'MOLINA_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT',
  MOLINA_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT = 'MOLINA_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT',
  MOLINA_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT = 'MOLINA_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT',
  MOLINA_FLORIDA_MEDICAID_INITIAL_ENGAGEMENT = 'MOLINA_FLORIDA_MEDICAID_INITIAL_ENGAGEMENT',
  MOLINA_FLORIDA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT = 'MOLINA_FLORIDA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT',
  MOLINA_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT = 'MOLINA_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT',
  MOLINA_MICHIGAN_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT = 'MOLINA_MICHIGAN_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT',
  MOLINA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT = 'MOLINA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT',
  MOLINA_UTAH_MEDICAID_INITIAL_ENGAGEMENT = 'MOLINA_UTAH_MEDICAID_INITIAL_ENGAGEMENT',
  MOLINA_UTAH_MEDICARE_INITIAL_ENGAGEMENT = 'MOLINA_UTAH_MEDICARE_INITIAL_ENGAGEMENT',

  OSCARCARE_FLORIDA_EXCHANGE_INITIAL_ENGAGEMENT = 'OSCARCARE_FLORIDA_EXCHANGE_INITIAL_ENGAGEMENT',
  OSCARCARE_NATIONAL_EXCHANGE_INITIAL_ENGAGEMENT = 'OSCARCARE_NATIONAL_EXCHANGE_INITIAL_ENGAGEMENT',
  OSCARHEALTH_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT = 'OSCARHEALTH_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT',
  OSCARHEALTH_FLORIDA_MEDICARE_INITIAL_ENGAGEMENT = 'OSCARHEALTH_FLORIDA_MEDICARE_INITIAL_ENGAGEMENT',

  TRAININGPARTNER_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT = 'TRAININGPARTNER_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT',

  UCIHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT = 'UCIHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT',
  UCIHEALTH_CALIFORNIA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT = 'UCIHEALTH_CALIFORNIA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT',

  UCLAHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT = 'UCLAHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT',
  UCLAHEALTH_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT = 'UCLAHEALTH_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT',

  UCSDHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT = 'UCSDHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT',

  UHC_MASSACHUSETTS_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT = 'UHC_MASSACHUSETTS_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT',

  WELLSENSE_MASSACHUSETTS_MEDICARE_INITIAL_ENGAGEMENT = 'WELLSENSE_MASSACHUSETTS_MEDICARE_INITIAL_ENGAGEMENT',
  WELLSENSE_NEWHAMPSHIRE_MEDICAID_INITIAL_ENGAGEMENT = 'WELLSENSE_NEWHAMPSHIRE_MEDICAID_INITIAL_ENGAGEMENT',
  WELLSENSE_NEWHAMPSHIRE_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT = 'WELLSENSE_NEWHAMPSHIRE_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT',
  WELLSENSE_NEWHAMPSHIRE_MEDICARE_INITIAL_ENGAGEMENT = 'WELLSENSE_NEWHAMPSHIRE_MEDICARE_INITIAL_ENGAGEMENT',
}

export enum CampaignChannel {
  DIGITAL_ONLY = 'DIGITAL_ONLY',
  TELEPHONIC_ONLY = 'TELEPHONIC_ONLY',
  OMNICHANNEL = 'OMNICHANNEL',
}

export type ServiceRequestTypeExternalIDsList = {
  externalID: string;
  labOrganization: LabOrganization;
}[];

export type ReportFileNameComponents = {
  // For file name, we will default to <partnerorg>_<patient_population>_SPRINTERHEALTH_ENGAGEMENT_REPORT_YYYYMMDD
  fileNamePrefixOverride?: string;
  fileNameBodyOverride?: string;
  fileNameSuffixOverride?: string;
};

export type AdvertisedIncentiveAmount =
  | {
      incentiveType: 'standardAcrossCampaign';
      advertisedIncentiveAmountUSD: Dollar;
    }
  | {
      incentiveType: 'standardAcrossCampaignIfServicesIncludeAnyFromApprovedList';
      advertisedIncentiveAmountUSD: Dollar;
      approvedServiceRequestTypeExternalIDs: ServiceRequestTypeExternalIDsList;
    };

// TODO(86ay9qy8j) Remove the isActive flag from the getCampaignConfig function
// and rename it to prevent confusion. This should be done anytime after 9/13/2023
export type CampaignConfig = {
  partnerOrganization: PartnerOrganization;

  /**
   * This is the age category that the campaign is targeting.
   * It is based on the services a patient is getting and should
   * primarily be used for five9 call routing
   */
  campaignAgeCategoryForFive9Routing: CampaignAgeCategory;
  campaignSeries: CampaignSeries;
  campaignChannel: CampaignChannel;
  campaignGroup: CampaignGroupName;
  campaignType: CampaignType;
  campaignDisplayName: string;
  /**
   * A patient's eligibility for a campaign is defined by the campaign's start and end dates.
   * Specifically, the end of the campaign is generally the patient's eligibility end date for which they could be
   * engaged and book appointments.
   *
   * There are specific cases where a campaign's outreach should end; however, a patient could book an appointment
   * past that date.
   */
  start: DateTime;
  end: DateTime;
  appointmentEligibilityEnd?: DateTime;
  /**
   * When the prod campaign is launched, we set isActive to true and update the eligibilityStart.
   * Note: once a campaign has been completed, we can set isActive to false and move it to the correct section below.
   */
  isActive: boolean;
  /**
   * This is a temporary flag to determine if a campaign is eligible for reactivation.
   * Ideally all campaigns should be eligible for reactivation, but because of a few reasons
   * we can only enable this for campaigns that have been refreshed in the new year.
   * This is something we should be able to remove near end of May 2025
   * TODO(86b4yvr8a) Remove this flag once we have audited all campaigns are safe to reactivate
   */
  isCampaignEligibleForReactivation?: boolean;
  shouldEligiblePatientsTrickle: boolean;
  /**
   * When we enable a campaign for the stale sequence, we need to:
   * - Set shouldStalePatientsTrickle to true
   * - Ensure there is approved follow up content
   * - Update the campaign cohort config to include DEFAULT_STALE_SEQUENCE_OMNICHANNEL_SCHEDULED_ACTIONS_BY_CAMPAIGN_STATE_NAME
   * - Ensure the engagement state machine supports the stale sequence state/transitions
   */
  shouldStalePatientsTrickle: boolean;
  shouldStale2PatientsTrickle: boolean;
  shouldStale3PatientsTrickle: boolean;
  shouldStale4PatientsTrickle: boolean;
  shouldStale5PatientsTrickle: boolean;
  shouldStale6PatientsTrickle: boolean;
  shouldStale7PatientsTrickle: boolean;
  shouldStale8PatientsTrickle: boolean;
  shouldStale9PatientsTrickle: boolean;
  population: PatientPopulation;
  // This represents the year a gap closure service is measured.
  // Even though we are moving towards the concept of campaigns being year-agnostic,
  // we still need the ability to identify when a service was requested (& potentially done).
  // This will make it easier to do year specific analysis (e.g. YOY change, current years performance, etc.)
  measurementYear: number;
  shouldUseCaregiverNameInOutreachContent?: boolean;
  advertisedIncentiveAmount?: AdvertisedIncentiveAmount;
  // For engagement reporting, we want these fields to be on the campaign level.
  // Namely, we want to know if a report should be generated and if we have a specific naming convention for the engagement report on the campaign.
  shouldGenerateEngagementReport?: boolean;
  engagementReportFileNameOverride?: ReportFileNameComponents;
  shouldSendMissedCallSMS: boolean;
  defaultBrandCode?: string;
  shouldContactEnrichedPhones?: boolean;
  emailFooterTrackingNumber?: string;
  /**
   * This flag will allow patient's to book appointments past their eligibility end date and appointment end date.
   * We have currently used this flag to allow patient's book appointments into the new year.
   * This flag should be set very intentionally and only set to false due to partner requests.
   */
  shouldRespectEligibilityEndDate: boolean;
  shouldUseCMSEmail?: boolean; // For our phased rollout of CMS email, we will use this flag to determine if we should use the CMS path
};

export const CAMPAIGN_CONFIG: { [key in CampaignName]: CampaignConfig } = {
  /*
   *  ----------------------- 2023 CAMPAIGNS ------------------------
   *
   */
  [CampaignName.OSCARCARE_VPC_FLORIDA_TELEPHONIC_ONLY_INITIAL_ENGAGEMENT_06_12_2023]: {
    partnerOrganization: PartnerOrganization.OSCAR,
    campaignSeries: CampaignSeries.OSCARCARE_FLORIDA_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL, // This campaign was later converted to have digital outreach, thus is a omnichannl campaign
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Oscar Care VPC FL Telephonic Only 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-06-12'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.ALIGNMENTSTARS_MEDICARE_CALIFORNIA_INITIAL_ENGAGEMENT_07_07_2023]: {
    partnerOrganization: PartnerOrganization.ALIGNMENTSTARS,
    campaignSeries: CampaignSeries.ALIGNMENTSTARS_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Alignment Stars Medicare CA 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-07-07'),
    end: DateTime.fromISO('2024-03-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.OSCARHEALTH_IFP_CALIFORNIA_INITIAL_ENGAGEMENT_07_20_2023]: {
    partnerOrganization: PartnerOrganization.OSCARHEALTH,
    campaignSeries: CampaignSeries.OSCARHEALTH_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Oscar Health IFP CA 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-07-20'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.OSCARHEALTH_MEDICARE_FLORIDA_DIGITAL_ONLY_INITIAL_ENGAGEMENT_07_27_2023]: {
    partnerOrganization: PartnerOrganization.OSCARHEALTH,
    campaignSeries: CampaignSeries.OSCARHEALTH_FLORIDA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.DIGITAL_ONLY,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Oscar Health Medicare FL Digital Only (Default) 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-07-27'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.OSCARHEALTH_MEDICARE_FLORIDA_DIGITAL_ONLY_EVENING_INITIAL_ENGAGEMENT_07_27_2023]: {
    partnerOrganization: PartnerOrganization.OSCARHEALTH,
    campaignSeries: CampaignSeries.OSCARHEALTH_FLORIDA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.DIGITAL_ONLY,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Oscar Health Medicare FL Digital Only (Evening) 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-07-27'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.MOLINA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.MOLINAMI,
    campaignSeries: CampaignSeries.MOLINA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Michigan Medicare 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-08-30'),
    end: DateTime.fromISO('2024-03-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },
  // TODO(86azcxxww) Mark this as inactive once 2024 is live and this campaign is closed out
  [CampaignName.MOLINA_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.MOLINAMI,
    campaignSeries: CampaignSeries.MOLINA_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Michigan Medicaid (Adult) 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-08-31'),
    end: DateTime.fromISO('2024-03-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.MOLINA_UTAH_MEDICAID_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.MOLINAUT,
    campaignSeries: CampaignSeries.MOLINA_UTAH_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Utah Medicaid 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-09-01'),
    end: DateTime.fromISO('2024-03-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.WELLSENSE_NEWHAMPSHIRE_MEDICARE_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.WELLSENSENHMEDICARE,
    campaignSeries: CampaignSeries.WELLSENSE_NEWHAMPSHIRE_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'WellSense New Hampshire Medicare 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-09-08'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.MOLINA_UTAH_MEDICARE_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.MOLINAUT,
    campaignSeries: CampaignSeries.MOLINA_UTAH_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Utah Medicare 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-09-13'),
    end: DateTime.fromISO('2024-03-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.WELLSENSE_MASSACHUSETTS_MEDICARE_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.WELLSENSE,
    campaignSeries: CampaignSeries.WELLSENSE_MASSACHUSETTS_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'WellSense Massachusetts Medicare 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-09-22'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.WELLSENSE_NEWHAMPSHIRE_MEDICAID_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.WELLSENSENHMEDICAID,
    campaignSeries: CampaignSeries.WELLSENSE_NEWHAMPSHIRE_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'WellSense New Hampshire Medicaid 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-09-25'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.MOLINA_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.MOLINACA,
    campaignSeries: CampaignSeries.MOLINA_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina California Medicare 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-10-11'),
    end: DateTime.fromISO('2024-03-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.MOLINA_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.MOLINACA,
    campaignSeries: CampaignSeries.MOLINA_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina California Exchange 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-10-18'),
    end: DateTime.fromISO('2024-03-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaignIfServicesIncludeAnyFromApprovedList' as const,
      advertisedIncentiveAmountUSD: makeDollar(25),
      approvedServiceRequestTypeExternalIDs: [
        {
          externalID: 'INSURE-ONE-FIT-KIT-DELIVERY-AND-EDUCATION',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
      ],
    },
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },
  // TODO(Patients): deprecate Lead Screening campaigns, check against referral services to override content
  [CampaignName.MOLINA_MICHIGAN_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.MOLINAMI,
    campaignSeries: CampaignSeries.MOLINA_MICHIGAN_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Michigan Medicaid (Lead Screening) 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2023-10-19'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },
  // TODO(dhruv): Deprecate this campaign once the 2024 campaign is live and we have updated
  // handle patients in multiple patient campaign states
  [CampaignName.OSCARCARE_VPC_FLORIDA_DIGITAL_ONLY_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.OSCAR,
    campaignSeries: CampaignSeries.OSCARCARE_FLORIDA_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.DIGITAL_ONLY,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Oscar Care VPC FL Digital Only 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-10-30'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },
  // TODO(Patients): deprecate Lead Screening campaigns, check against referral services to override content
  [CampaignName.WELLSENSE_NEWHAMPSHIRE_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.WELLSENSENHMEDICAID,
    campaignSeries:
      CampaignSeries.WELLSENSE_NEWHAMPSHIRE_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'WellSense New Hampshire Medicaid (Lead Screening) 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2023-11-01'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },
  // TODO(Patients): deprecate Lead Screening campaigns, check against referral services to override content
  // TODO(dhruv): Deprecate this campaign once the 2024 campaign for lead screening is live and we have updated
  // handle patients in multiple patient campaign states
  [CampaignName.UCIHEALTH_CALIFORNIA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.UCIHEALTH,
    campaignSeries: CampaignSeries.UCIHEALTH_CALIFORNIA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UCI Health California Medicaid (Lead Screening) 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2023-10-31'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.UCIHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.UCIHEALTH,
    campaignSeries: CampaignSeries.UCIHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UCI Health California Medicaid (Adult) 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-11-03'),
    end: DateTime.fromISO('2023-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },

  [CampaignName.MOLINA_FLORIDA_MEDICAID_INITIAL_ENGAGEMENT_2023]: {
    partnerOrganization: PartnerOrganization.MOLINAFL,
    campaignSeries: CampaignSeries.MOLINA_FLORIDA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Florida Medicaid 2023',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-12-01'),
    end: DateTime.fromISO('2024-03-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2023,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaignIfServicesIncludeAnyFromApprovedList' as const,
      advertisedIncentiveAmountUSD: makeDollar(20),
      approvedServiceRequestTypeExternalIDs: [
        { externalID: '496', labOrganization: LabOrganization.QUEST },
        {
          externalID: 'DIABETIC-RETINAL-SCAN',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
      ],
    },
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },

  /*
   *  ----------------------- 2024 CAMPAIGNS ------------------------
   *
   */

  // TODO(Patients): deprecate Lead Screening campaigns, check against referral services to override content
  [CampaignName.UCIHEALTH_CALIFORNIA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.UCIHEALTH,
    campaignSeries: CampaignSeries.UCIHEALTH_CALIFORNIA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UCI Health California Medicaid (Lead Screening) 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2024-01-20'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldGenerateEngagementReport: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: false,
  },

  [CampaignName.OSCARCARE_FLORIDA_EXCHANGE_DIGITAL_ONLY_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.OSCAR,
    campaignSeries: CampaignSeries.OSCARCARE_FLORIDA_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.DIGITAL_ONLY,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Oscar Care VPC FL Digital Only 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-02-09'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.OSCARCARE_NATIONAL_EXCHANGE_DIGITAL_ONLY_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.OSCAR,
    campaignSeries: CampaignSeries.OSCARCARE_NATIONAL_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.DIGITAL_ONLY,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Oscar Care Exchange National Digital Only 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-05-28'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.MOLINA_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINAMI,
    campaignSeries: CampaignSeries.MOLINA_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Michigan Medicaid (Adult) 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-02-16'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.MOLINA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINAMI,
    campaignSeries: CampaignSeries.MOLINA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Michigan Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-08-19'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.ELEVANCEHEALTH_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.ELEVANCEHEALTH,
    campaignSeries: CampaignSeries.ELEVANCEHEALTH_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Elevance Health National Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-03-01'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    // Elevance wants the engagement report file name to follow this format:
    // YYYY_SPRINTERHEALTH_ENGAGEMENT_REPORT_YYYYMMDD
    // YYYY: File prefix that we are overriding
    // SPRINTERHEALTH_ENGAGEMENT_REPORT: Default file body
    // YYYYMMDD: Default file suffix
    engagementReportFileNameOverride: {
      fileNamePrefixOverride: `${DateTime.now().setZone(DEFAULT_TIMEZONE_PT).year}`,
    },
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.UCIHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.UCIHEALTH,
    campaignSeries: CampaignSeries.UCIHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UCI Health California Medicaid (Adult) 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-03-01'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldGenerateEngagementReport: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.UCLAHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.UCLAHEALTH,
    campaignSeries: CampaignSeries.UCLAHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UCLA Health California Medicaid (Adult) 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-12-01'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldGenerateEngagementReport: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.TRAININGPARTNER_NATIONAL_MEDICARE_CAMPAIGN_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.TRAININGPARTNER,
    campaignSeries: CampaignSeries.TRAININGPARTNER_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Training Partner Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-03-01'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // as this is solely for testing purposes we are assuming that patients will be manually moved
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: false,
  },

  [CampaignName.MOLINA_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINACA,
    campaignSeries: CampaignSeries.MOLINA_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina California Exchange 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-03-20'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaignIfServicesIncludeAnyFromApprovedList' as const,
      advertisedIncentiveAmountUSD: makeDollar(50),
      approvedServiceRequestTypeExternalIDs: [
        {
          externalID: 'INSURE-ONE-FIT-KIT-DELIVERY-AND-EDUCATION',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
        {
          externalID: 'COLOGUARD-KIT-EDUCATION',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
      ],
    },
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false,
  },

  [CampaignName.MOLINA_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINACA,
    campaignSeries: CampaignSeries.MOLINA_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina California Medicaid (Adult) 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-07-16'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldGenerateEngagementReport: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false,
  },

  [CampaignName.MOLINA_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINACA,
    campaignSeries: CampaignSeries.MOLINA_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina California Medicaid (Pediatric) 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2024-07-12'),
    end: DateTime.fromISO('2024-12-31'),
    engagementReportFileNameOverride: {
      fileNamePrefixOverride: 'MOLINACA_MEDICAID_PEDIATRIC',
    },
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldGenerateEngagementReport: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldSendMissedCallSMS: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false,
  },

  [CampaignName.MOLINA_FLORIDA_MEDICAID_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINAFL,
    campaignSeries: CampaignSeries.MOLINA_FLORIDA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Florida Medicaid (Adult) 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-04-02'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaignIfServicesIncludeAnyFromApprovedList' as const,
      advertisedIncentiveAmountUSD: makeDollar(40),
      approvedServiceRequestTypeExternalIDs: [
        { externalID: '496', labOrganization: LabOrganization.QUEST },
        {
          externalID: 'DIABETIC-RETINAL-SCAN',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
      ],
    },
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.MOLINA_UTAH_MEDICAID_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINAUT,
    campaignSeries: CampaignSeries.MOLINA_UTAH_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Utah Medicaid (Adult) 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-04-02'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaignIfServicesIncludeAnyFromApprovedList' as const,
      advertisedIncentiveAmountUSD: makeDollar(200),
      approvedServiceRequestTypeExternalIDs: [
        { externalID: '496', labOrganization: LabOrganization.QUEST },
        {
          externalID: 'DIABETIC-RETINAL-SCAN',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
        {
          externalID: 'MAMMOGRAM_CARE_NAVIGATION_BOOKING',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
        {
          externalID: 'MAMMOGRAM_CARE_NAVIGATION_CONFIRMATION',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
      ],
    },
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.MOLINA_UTAH_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINAUT,
    campaignSeries: CampaignSeries.MOLINA_UTAH_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Utah Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-04-02'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaignIfServicesIncludeAnyFromApprovedList' as const,
      advertisedIncentiveAmountUSD: makeDollar(270),
      approvedServiceRequestTypeExternalIDs: [
        { externalID: '496', labOrganization: LabOrganization.QUEST },
        { externalID: '375', labOrganization: LabOrganization.QUEST },
        { externalID: '6517', labOrganization: LabOrganization.QUEST },
        {
          externalID: 'DIABETIC-RETINAL-SCAN',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
        {
          externalID: 'BLOOD-PRESSURE-CHECK',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
        {
          externalID: 'INSURE-ONE-FIT-KIT-DELIVERY-AND-EDUCATION',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
        {
          externalID: 'COLOGUARD-KIT-EDUCATION',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
      ],
    },
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.MOLINA_MICHIGAN_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINAMI,
    campaignSeries: CampaignSeries.MOLINA_MICHIGAN_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Michigan Medicaid (Lead Screening) 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2024-04-22'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldGenerateEngagementReport: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldUseCaregiverNameInOutreachContent: true,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaign' as const,
      advertisedIncentiveAmountUSD: makeDollar(25),
    },
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: false,
  },

  [CampaignName.MOLINA_FLORIDA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINAFL,
    campaignSeries: CampaignSeries.MOLINA_FLORIDA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Florida Medicaid (Lead Screening) 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2024-05-15'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldGenerateEngagementReport: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldUseCaregiverNameInOutreachContent: true,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaign' as const,
      advertisedIncentiveAmountUSD: makeDollar(20),
    },
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: true,
  },

  [CampaignName.ALIGNMENTSTARS_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.ALIGNMENTSTARS,
    campaignSeries: CampaignSeries.ALIGNMENTSTARS_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Alignment Stars Medicare CA 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-05-09'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldGenerateEngagementReport: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: true,
  },

  [CampaignName.CENTENE_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENECA,
    campaignSeries: CampaignSeries.CENTENE_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene California Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-05-07'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_FLORIDA_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEFL,
    campaignSeries: CampaignSeries.CENTENE_FLORIDA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Florida Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-10-01'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_GEORGIA_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEGA,
    campaignSeries: CampaignSeries.CENTENE_GEORGIA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Georgia Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-09-13'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_KENTUCKY_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEKY,
    campaignSeries: CampaignSeries.CENTENE_KENTUCKY_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Kentucky Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-09-13'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_KENTUCKY_MEDICAID_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEKY,
    campaignSeries: CampaignSeries.CENTENE_KENTUCKY_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Kentucky Medicaid 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-10-11'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_KENTUCKY_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEKY,
    campaignSeries: CampaignSeries.CENTENE_KENTUCKY_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Kentucky Medicaid Pediatric 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2024-10-24'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldGenerateEngagementReport: false,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_MASSACHUSETTS_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEMA,
    campaignSeries: CampaignSeries.CENTENE_MASSACHUSETTS_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Massachusetts Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-05-07'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_MAINE_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEME,
    campaignSeries: CampaignSeries.CENTENE_MAINE_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Maine Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-10-01'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_INDIANA_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEIN,
    campaignSeries: CampaignSeries.CENTENE_INDIANA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Indiana Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-10-01'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_CONNECTICUT_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENECT,
    campaignSeries: CampaignSeries.CENTENE_CONNECTICUT_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Connecticut Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-10-01'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: false as const, // TODO(86b2cjdtg) This will be activated when we are ready to launch
    shouldEligiblePatientsTrickle: false, // TODO(86b2cjdtg) This will be activated when we are ready to launch
    shouldStalePatientsTrickle: false, // TODO(86b2cjdtg) This will be activated when we are ready to launch
    shouldStale2PatientsTrickle: false, // TODO(86b2cjdtg) This will be activated when we are ready to launch
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_TEXAS_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENETX,
    campaignSeries: CampaignSeries.CENTENE_TEXAS_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Texas Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-10-01'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: false as const, // TODO(86b2cjczt) This will be activated when we are ready to launch
    shouldEligiblePatientsTrickle: false, // TODO(86b2cjczt) This will be activated when we are ready to launch
    shouldStalePatientsTrickle: false, // TODO(86b2cjczt) This will be activated when we are ready to launch
    shouldStale2PatientsTrickle: false, // TODO(86b2cjczt) This will be activated when we are ready to launch
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_MICHIGAN_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEMI,
    campaignSeries: CampaignSeries.CENTENE_MICHIGAN_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Michigan Duals 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-09-03'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.DUAL_MEDICAID_MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEMI,
    campaignSeries: CampaignSeries.CENTENE_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Michigan Medicaid 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-10-21'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    defaultBrandCode: 'MERIDIANHP',
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEMI,
    campaignSeries: CampaignSeries.CENTENE_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Michigan Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-05-07'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false, // TODO: Reduce SMS length for Meridian brands before enabling
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_NEWHAMPSHIRE_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENENH,
    campaignSeries: CampaignSeries.CENTENE_NEWHAMPSHIRE_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene New Hampshire Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-05-07'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_OHIO_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEOH,
    campaignSeries: CampaignSeries.CENTENE_OHIO_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Ohio Duals 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-11-05'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.DUAL_MEDICAID_MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false, // TODO: Reduce SMS length for Buckeye Health Plan - MyCare Ohio brand before enabling
    shouldGenerateEngagementReport: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_OHIO_EXCHANGE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEOH,
    campaignSeries: CampaignSeries.CENTENE_OHIO_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Ohio Exchange 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-11-11'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    defaultBrandCode: 'ABHPDEFAULT',
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_OHIO_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEOH,
    campaignSeries: CampaignSeries.CENTENE_OHIO_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Ohio Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-05-07'),
    end: DateTime.fromISO('2025-01-31'),
    appointmentEligibilityEnd: DateTime.fromISO('2025-02-28'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false, // TODO: Reduce SMS length for Buckeye Health Plan - MyCare Ohio brand before enabling
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_NEWHAMPSHIRE_EXCHANGE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENENH,
    campaignSeries: CampaignSeries.CENTENE_NEWHAMPSHIRE_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene New Hampshire Exchange 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-05-07'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.UHC_MASSACHUSETTS_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.UHCMA,
    campaignSeries: CampaignSeries.UHC_MASSACHUSETTS_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UnitedHealthcare Massachusetts Duals 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-07-26'),
    end: DateTime.fromISO('2024-12-31'),
    isActive: true,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    population: PatientPopulation.DUAL_MEDICAID_MEDICARE,
    measurementYear: 2024,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_OHIO_MEDICAID_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.CENTENEOH,
    campaignSeries: CampaignSeries.CENTENE_OHIO_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Ohio Medicaid 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-08-06'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    defaultBrandCode: 'BHPDEFAULT',
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.MOLINA_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.MOLINACA,
    campaignSeries: CampaignSeries.MOLINA_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina California Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-08-22'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldGenerateEngagementReport: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaignIfServicesIncludeAnyFromApprovedList' as const,
      advertisedIncentiveAmountUSD: makeDollar(190),
      approvedServiceRequestTypeExternalIDs: [
        { externalID: '496', labOrganization: LabOrganization.QUEST },
        {
          externalID: 'DIABETIC-RETINAL-SCAN',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
        { externalID: 'BLOOD-PRESSURE-CHECK', labOrganization: LabOrganization.SPRINTER_HEALTH },
        { externalID: '375', labOrganization: LabOrganization.QUEST },
        { externalID: '6517', labOrganization: LabOrganization.QUEST },
        { externalID: 'COLOGUARD-KIT-EDUCATION', labOrganization: LabOrganization.SPRINTER_HEALTH },
        {
          externalID: 'INSURE-ONE-FIT-KIT-DELIVERY-AND-EDUCATION',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
      ],
    },
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: true, // TODO check with config
  },
  [CampaignName.HUMANA_NEWYORK_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.HUMANANY,
    campaignSeries: CampaignSeries.HUMANA_NEWYORK_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Humana New York Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-09-04'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldGenerateEngagementReport: false,
    emailFooterTrackingNumber: 'Y0040_GHHMCUJEN_C',
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaign' as const,
      advertisedIncentiveAmountUSD: makeDollar(40),
    },
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.HUMANA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.HUMANAMI,
    campaignSeries: CampaignSeries.HUMANA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Humana Michigan Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-10-07'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldGenerateEngagementReport: false,
    emailFooterTrackingNumber: 'Y0040_GHHMCUJEN_C',
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaign' as const,
      advertisedIncentiveAmountUSD: makeDollar(40),
    },
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.HUMANA_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT_2024]: {
    partnerOrganization: PartnerOrganization.HUMANA,
    campaignSeries: CampaignSeries.HUMANA_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Humana National Medicare 2024',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2024-10-30'),
    end: DateTime.fromISO('2024-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2024,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false,
    emailFooterTrackingNumber: 'Y0040_GHHMCUJEN_C',
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaign' as const,
      advertisedIncentiveAmountUSD: makeDollar(40),
    },
    engagementReportFileNameOverride: {
      fileNamePrefixOverride: 'HUMANA_NATIONAL_MEDICARE',
    },
    shouldRespectEligibilityEndDate: false,
  },

  /*
   *  ----------------------- 2025 CAMPAIGNS ------------------------
   *
   */

  // TODO(Patients): deprecate Lead Screening campaigns, check against referral services to override content
  [CampaignName.UCIHEALTH_CALIFORNIA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.UCIHEALTH,
    campaignSeries: CampaignSeries.UCIHEALTH_CALIFORNIA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UCI Health California Medicaid (Lead Screening) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: false, // 2024 value: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldGenerateEngagementReport: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
    shouldSendMissedCallSMS: false,
  },

  [CampaignName.OSCARCARE_FLORIDA_EXCHANGE_DIGITAL_ONLY_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.OSCAR,
    campaignSeries: CampaignSeries.OSCARCARE_FLORIDA_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.DIGITAL_ONLY,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Oscar Care VPC FL Digital Only 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // 2024 value: true,
    shouldStalePatientsTrickle: false, // 2024 value: false,
    shouldStale2PatientsTrickle: false, // 2024 value: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.OSCARCARE_NATIONAL_EXCHANGE_DIGITAL_ONLY_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.OSCAR,
    campaignSeries: CampaignSeries.OSCARCARE_NATIONAL_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.DIGITAL_ONLY,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Oscar Care Exchange National Digital Only 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // 2024 value: true,
    shouldStalePatientsTrickle: false, // 2024 value: false,
    shouldStale2PatientsTrickle: false, // 2024 value: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.MOLINA_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINAMI,
    campaignSeries: CampaignSeries.MOLINA_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Michigan Medicaid (Adult) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  // TODO(86b38w22x): get the actual incentive amounts from Madi; at the moment, this campaign does not have incentives
  [CampaignName.MOLINA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINAMI,
    campaignSeries: CampaignSeries.MOLINA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Michigan Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStalePatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale2PatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale3PatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale4PatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale5PatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale6PatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale7PatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale8PatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale9PatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
    shouldUseCMSEmail: true,
  },
  [CampaignName.ELEVANCEHEALTH_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.ELEVANCEHEALTH,
    campaignSeries: CampaignSeries.ELEVANCEHEALTH_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Elevance Health National Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    isCampaignEligibleForReactivation: true,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    // Elevance wants the engagement report file name to follow this format:
    // YYYY_SPRINTERHEALTH_ENGAGEMENT_REPORT_YYYYMMDD
    // YYYY: File prefix that we are overriding
    // SPRINTERHEALTH_ENGAGEMENT_REPORT: Default file body
    // YYYYMMDD: Default file suffix
    engagementReportFileNameOverride: {
      fileNamePrefixOverride: `${DateTime.now().setZone(DEFAULT_TIMEZONE_PT).year}`,
    },
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
    shouldUseCMSEmail: true,
  },
  [CampaignName.UCIHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.UCIHEALTH,
    campaignSeries: CampaignSeries.UCIHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UCI Health California Medicaid (Adult) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: false, // 2024 value: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldGenerateEngagementReport: true, // 2024 value: true,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.UCLAHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.UCLAHEALTH,
    campaignSeries: CampaignSeries.UCLAHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UCLA Health California Medicaid (Adult) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldGenerateEngagementReport: true,
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.UCLAHEALTH_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.UCLAHEALTH,
    campaignSeries: CampaignSeries.UCLAHEALTH_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UCLA Health California Medicaid (Pediatric) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2025-03-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldGenerateEngagementReport: true,
    shouldSendMissedCallSMS: false, // There is no copy for post-call SMSs
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.TRAININGPARTNER_NATIONAL_MEDICARE_CAMPAIGN_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.TRAININGPARTNER,
    campaignSeries: CampaignSeries.TRAININGPARTNER_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Training Partner Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // 2024 value: false, // as this is solely for testing purposes we are assuming that patients will be manually moved
    shouldStalePatientsTrickle: false, // 2024 value: false,
    shouldStale2PatientsTrickle: false, // 2024 value: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },

  [CampaignName.MOLINA_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINACA,
    campaignSeries: CampaignSeries.MOLINA_CALIFORNIA_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina California Exchange 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    // TODO(86b38w22x): get the actual incentive amounts from Madi; for now, we will remove incentives
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },

  [CampaignName.MOLINA_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINACA,
    campaignSeries: CampaignSeries.MOLINA_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina California Medicaid (Adult) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldGenerateEngagementReport: true,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },

  [CampaignName.MOLINA_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINACA,
    campaignSeries: CampaignSeries.MOLINA_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina California Medicaid (Pediatric) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    engagementReportFileNameOverride: {
      fileNamePrefixOverride: 'MOLINACA_MEDICAID_PEDIATRIC',
    },
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldGenerateEngagementReport: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldSendMissedCallSMS: false,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },

  [CampaignName.MOLINA_FLORIDA_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINAFL,
    campaignSeries: CampaignSeries.MOLINA_FLORIDA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Florida Medicaid (Adult) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // TODO(engagement): Enable after the first gap list refresh in 2025
    shouldStalePatientsTrickle: false, // TODO(engagement): Enable after the first gap list refresh in 2025
    shouldStale2PatientsTrickle: false, // TODO(engagement): Enable after the first gap list refresh in 2025
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    // TODO(86b38w22x): get the actual incentive amounts from Madi; for now, we will remove incentives
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false, // TODO(engagement): Enable after the first gap list refresh in 2025
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },

  [CampaignName.MOLINA_UTAH_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINAUT,
    campaignSeries: CampaignSeries.MOLINA_UTAH_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Utah Medicaid (Adult) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // TODO(patient): re-enable after we've ingested the refresh
    shouldStalePatientsTrickle: false, // TODO(patient): re-enable after we've ingested the refresh
    shouldStale2PatientsTrickle: false, // TODO(patient): re-enable after we've ingested the refresh
    shouldStale3PatientsTrickle: false, // TODO(patient): re-enable after we've ingested the refresh
    shouldStale4PatientsTrickle: false, // TODO(patient): re-enable after we've ingested the refresh
    shouldStale5PatientsTrickle: false, // TODO(patient): re-enable after we've ingested the refresh
    shouldStale6PatientsTrickle: false, // TODO(patient): re-enable after we've ingested the refresh
    shouldStale7PatientsTrickle: false, // TODO(patient): re-enable after we've ingested the refresh
    shouldStale8PatientsTrickle: false, // TODO(patient): re-enable after we've ingested the refresh
    shouldStale9PatientsTrickle: false, // TODO(patient): re-enable after we've ingested the refresh
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.MOLINA_UTAH_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINAUT,
    campaignSeries: CampaignSeries.MOLINA_UTAH_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Utah Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStalePatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale2PatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    // TODO(86b38w22x): get the actual incentive amounts from Madi; for now, we will remove incentives
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.MOLINA_MICHIGAN_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINAMI,
    campaignSeries: CampaignSeries.MOLINA_MICHIGAN_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Michigan Medicaid (Lead Screening) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldGenerateEngagementReport: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },

  [CampaignName.MOLINA_FLORIDA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINAFL,
    campaignSeries: CampaignSeries.MOLINA_FLORIDA_MEDICAID_LEAD_SCREENING_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina Florida Medicaid (Lead Screening) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldGenerateEngagementReport: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldStalePatientsTrickle: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldStale2PatientsTrickle: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldStale3PatientsTrickle: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldStale4PatientsTrickle: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldStale5PatientsTrickle: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldStale6PatientsTrickle: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldStale7PatientsTrickle: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldStale8PatientsTrickle: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldStale9PatientsTrickle: false, // TODO(engagement) Enable this when we get a new 2025 gap list
    shouldUseCaregiverNameInOutreachContent: true,
    // TODO(86b38w22x): get the actual incentive amounts from Madi; for now, we will remove incentives
    shouldSendMissedCallSMS: false,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },

  // TODO(Patient)(86b489267): convert this campaign to a National campaign. For now,
  // we're effectively already treating it as a National campaign, which can have patients in any US state.
  [CampaignName.ALIGNMENTSTARS_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.ALIGNMENTSTARS,
    campaignSeries: CampaignSeries.ALIGNMENTSTARS_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Alignment Stars Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldGenerateEngagementReport: true,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaignIfServicesIncludeAnyFromApprovedList' as const,
      advertisedIncentiveAmountUSD: makeDollar(20),
      approvedServiceRequestTypeExternalIDs: [
        {
          externalID: 'DIABETIC-RETINAL-SCAN',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
      ],
    },
    shouldSendMissedCallSMS: true,
    shouldRespectEligibilityEndDate: false,
  },

  [CampaignName.CENTENE_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENECA,
    campaignSeries: CampaignSeries.CENTENE_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene California Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENECA,
    campaignSeries: CampaignSeries.CENTENE_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene California Medicaid 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-06-23'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    defaultBrandCode: 'HNCA',
    shouldGenerateEngagementReport: true,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_MISSISSIPPI_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEMS,
    campaignSeries: CampaignSeries.CENTENE_MISSISSIPPI_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Mississippi Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-06-26'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false,
    shouldUseCMSEmail: true,
  },
  [CampaignName.CENTENE_FLORIDA_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEFL,
    campaignSeries: CampaignSeries.CENTENE_FLORIDA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Florida Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    // TODO(engagement): Eligibility end date should be 1/31/2025 based on the tracker
    // https://docs.google.com/spreadsheets/d/16-499B1msjYQzNJFOO8JycO_SrH4DPGOrYwSxCkQO-E/edit?gid=0#gid=0
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_GEORGIA_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEGA,
    campaignSeries: CampaignSeries.CENTENE_GEORGIA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Georgia Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    // TODO(engagement): Eligibility end date should be 1/31/2025 based on the tracker
    // https://docs.google.com/spreadsheets/d/16-499B1msjYQzNJFOO8JycO_SrH4DPGOrYwSxCkQO-E/edit?gid=0#gid=0
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_KENTUCKY_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEKY,
    campaignSeries: CampaignSeries.CENTENE_KENTUCKY_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Kentucky Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_KENTUCKY_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEKY,
    campaignSeries: CampaignSeries.CENTENE_KENTUCKY_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Kentucky Medicaid 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    defaultBrandCode: 'KYMCD',
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_KENTUCKY_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEKY,
    campaignSeries: CampaignSeries.CENTENE_KENTUCKY_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Kentucky Medicaid Pediatric 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: false,
    shouldGenerateEngagementReport: true,
    defaultBrandCode: 'KYMCD',
    shouldUseCaregiverNameInOutreachContent: true,
    shouldRespectEligibilityEndDate: false,
    shouldUseCMSEmail: true,
  },
  [CampaignName.CENTENE_MASSACHUSETTS_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEMA,
    campaignSeries: CampaignSeries.CENTENE_MASSACHUSETTS_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Massachusetts Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldContactEnrichedPhones: true,
    shouldGenerateEngagementReport: true,
    // TODO(engagement): Eligibility end date should be 1/31/2025 based on the tracker
    // https://docs.google.com/spreadsheets/d/16-499B1msjYQzNJFOO8JycO_SrH4DPGOrYwSxCkQO-E/edit?gid=0#gid=0
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_MAINE_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEME,
    campaignSeries: CampaignSeries.CENTENE_MAINE_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Maine Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_INDIANA_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEIN,
    campaignSeries: CampaignSeries.CENTENE_INDIANA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Indiana Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_CONNECTICUT_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENECT,
    campaignSeries: CampaignSeries.CENTENE_CONNECTICUT_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Connecticut Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const, // TODO(86b2cjdtg) This will be activated when we are ready to launch
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.CENTENE_TEXAS_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENETX,
    campaignSeries: CampaignSeries.CENTENE_TEXAS_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Texas Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.CENTENE_TEXAS_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENETX,
    campaignSeries: CampaignSeries.CENTENE_TEXAS_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Texas Duals 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-05-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.DUAL_MEDICAID_MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldRespectEligibilityEndDate: false,
    shouldUseCMSEmail: true,
  },
  [CampaignName.CENTENE_MICHIGAN_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEMI,
    campaignSeries: CampaignSeries.CENTENE_MICHIGAN_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Michigan Duals 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.DUAL_MEDICAID_MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEMI,
    campaignSeries: CampaignSeries.CENTENE_MICHIGAN_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Michigan Medicaid 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    defaultBrandCode: 'MERIDIANHP',
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.CENTENE_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEMI,
    campaignSeries: CampaignSeries.CENTENE_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Michigan Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: false, // TODO: Reduce SMS length for Meridian brands before enabling
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_NEWHAMPSHIRE_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENENH,
    campaignSeries: CampaignSeries.CENTENE_NEWHAMPSHIRE_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene New Hampshire Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    shouldContactEnrichedPhones: true,
    shouldGenerateEngagementReport: true,
    // TODO(engagement): Eligibility end date should be 1/31/2025 based on the tracker
    // https://docs.google.com/spreadsheets/d/16-499B1msjYQzNJFOO8JycO_SrH4DPGOrYwSxCkQO-E/edit?gid=0#gid=0
    shouldRespectEligibilityEndDate: true,
  },
  [CampaignName.CENTENE_OHIO_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEOH,
    campaignSeries: CampaignSeries.CENTENE_OHIO_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Ohio Duals 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.DUAL_MEDICAID_MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: false, // TODO: Reduce SMS length for Buckeye Health Plan - MyCare Ohio brand before enabling
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_OHIO_EXCHANGE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEOH,
    campaignSeries: CampaignSeries.CENTENE_OHIO_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Ohio Exchange 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStalePatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale2PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale3PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale4PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale5PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale6PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale7PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale8PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale9PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    defaultBrandCode: 'ABHPDEFAULT',
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.CENTENE_OHIO_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEOH,
    campaignSeries: CampaignSeries.CENTENE_OHIO_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Ohio Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: false, // TODO: Reduce SMS length for Buckeye Health Plan - MyCare Ohio brand before enabling
    shouldGenerateEngagementReport: true,
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTENE_NEWHAMPSHIRE_EXCHANGE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENENH,
    campaignSeries: CampaignSeries.CENTENE_NEWHAMPSHIRE_EXCHANGE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene New Hampshire Exchange 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.EXCHANGE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStalePatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale2PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale3PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale4PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale5PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale6PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale7PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale8PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale9PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.UHC_MASSACHUSETTS_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.UHCMA,
    campaignSeries: CampaignSeries.UHC_MASSACHUSETTS_DUAL_MEDICAID_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UnitedHealthcare Massachusetts Duals 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    isActive: true,
    shouldEligiblePatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStalePatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale2PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale3PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale4PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale5PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale6PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale7PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale8PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldStale9PatientsTrickle: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    population: PatientPopulation.DUAL_MEDICAID_MEDICARE,
    measurementYear: 2025,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: false, // TODO(engagement) Enable this once we get the first 2025 gap list
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.CENTENE_OHIO_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTENEOH,
    campaignSeries: CampaignSeries.CENTENE_OHIO_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Centene Ohio Medicaid 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-04-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    defaultBrandCode: 'BHPDEFAULT',
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.CENTRALCALIFORNIAALLIANCEFORHEALTH_CALIFORNIA_MEDICAID_ADULT_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTRALCALIFORNIAALLIANCEFORHEALTH,
    campaignSeries:
      CampaignSeries.CENTRALCALIFORNIAALLIANCEFORHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Central California Alliance for Health California Medicaid (Adult) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    engagementReportFileNameOverride: {
      fileNamePrefixOverride: 'CENTRALCALIFORNIAALLIANCEFORHEALTH_MEDICAID_ADULT',
    },
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldContactEnrichedPhones: false,
    shouldGenerateEngagementReport: true,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.CENTRALCALIFORNIAALLIANCEFORHEALTH_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.CENTRALCALIFORNIAALLIANCEFORHEALTH,
    campaignSeries:
      CampaignSeries.CENTRALCALIFORNIAALLIANCEFORHEALTH_CALIFORNIA_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName:
      'Central California Alliance for Health California Medicaid (Pediatric) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    engagementReportFileNameOverride: {
      fileNamePrefixOverride: 'CENTRALCALIFORNIAALLIANCEFORHEALTH_MEDICAID_PEDIATRIC',
    },
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: false,
    shouldContactEnrichedPhones: false,
    shouldGenerateEngagementReport: true,
    // We should not be using any names in the content we send to CCAH patients as requested by the partner
    shouldUseCaregiverNameInOutreachContent: false,
    shouldRespectEligibilityEndDate: false,
  },
  [CampaignName.MOLINA_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.MOLINACA,
    campaignSeries: CampaignSeries.MOLINA_CALIFORNIA_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Molina California Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2023-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldGenerateEngagementReport: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStalePatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale2PatientsTrickle: false, // TODO(engagement): This should only be enabled after the first gap list refresh in 2025 & any cutover patients have been moved to ineligible
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: true,
    // TODO(86b38w22x): get the actual incentive amounts from Madi; for now, we will remove incentives
    shouldContactEnrichedPhones: true,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.HUMANA_NEWYORK_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.HUMANANY,
    campaignSeries: CampaignSeries.HUMANA_NEWYORK_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Humana New York Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldGenerateEngagementReport: false,
    emailFooterTrackingNumber: 'Y0040_GHHMCUJEN_C',
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaign' as const,
      advertisedIncentiveAmountUSD: makeDollar(40),
    },
    shouldContactEnrichedPhones: false,
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.HUMANA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.HUMANAMI,
    campaignSeries: CampaignSeries.HUMANA_MICHIGAN_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Humana Michigan Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldSendMissedCallSMS: false,
    shouldGenerateEngagementReport: false,
    emailFooterTrackingNumber: 'Y0040_GHHMCUJEN_C',
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaign' as const,
      advertisedIncentiveAmountUSD: makeDollar(40),
    },
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
  },
  [CampaignName.HUMANA_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.HUMANA,
    campaignSeries: CampaignSeries.HUMANA_NATIONAL_MEDICARE_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Humana National Medicare 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-01-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICARE,
    measurementYear: 2025,
    isActive: true as const,
    isCampaignEligibleForReactivation: true,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldGenerateEngagementReport: true,
    emailFooterTrackingNumber: 'Y0040_GHHMCUJEN_C',
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaign' as const,
      advertisedIncentiveAmountUSD: makeDollar(40),
    },
    engagementReportFileNameOverride: {
      fileNamePrefixOverride: 'HUMANA_NATIONAL_MEDICARE',
    },
    shouldRespectEligibilityEndDate: false, // this may need to be updated end of 2025 depending on 2025->2026 transition rules
    shouldUseCMSEmail: true,
  },
  [CampaignName.UCSDHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.UCSDHEALTH,
    campaignSeries: CampaignSeries.UCSDHEALTH_CALIFORNIA_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'UC San Diego Health Medicaid 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-03-10'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldContactEnrichedPhones: false,
    shouldGenerateEngagementReport: true,
    shouldRespectEligibilityEndDate: false,
  },

  [CampaignName.AETNA_ILLINOIS_MEDICAID_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.AETNA,
    campaignSeries: CampaignSeries.AETNA_ILLINOIS_MEDICAID_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Aetna Illinois Medicaid (Adult) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.ADULT,
    start: DateTime.fromISO('2025-03-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    isCampaignEligibleForReactivation: true,
    shouldEligiblePatientsTrickle: true,
    shouldStalePatientsTrickle: true,
    shouldStale2PatientsTrickle: true,
    shouldStale3PatientsTrickle: true,
    shouldStale4PatientsTrickle: true,
    shouldStale5PatientsTrickle: true,
    shouldStale6PatientsTrickle: true,
    shouldStale7PatientsTrickle: true,
    shouldStale8PatientsTrickle: true,
    shouldStale9PatientsTrickle: true,
    shouldSendMissedCallSMS: true,
    shouldContactEnrichedPhones: false,
    shouldGenerateEngagementReport: true,
    defaultBrandCode: 'SH-ABH-IL',
    shouldRespectEligibilityEndDate: false,
    advertisedIncentiveAmount: {
      incentiveType: 'standardAcrossCampaignIfServicesIncludeAnyFromApprovedList' as const,
      advertisedIncentiveAmountUSD: makeDollar(125),
      approvedServiceRequestTypeExternalIDs: [
        { externalID: '496', labOrganization: LabOrganization.QUEST },
        {
          externalID: 'BLOOD-PRESSURE-CHECK',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
        {
          externalID: 'MAMMOGRAM_CARE_NAVIGATION_BOOKING',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
        {
          externalID: 'MAMMOGRAM_CARE_NAVIGATION_CONFIRMATION',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
        {
          externalID: 'ADULT_PREVENTIVE_VISIT',
          labOrganization: LabOrganization.SPRINTER_HEALTH,
        },
      ],
    },
    shouldUseCMSEmail: true,
  },
  [CampaignName.AETNA_ILLINOIS_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT_2025]: {
    partnerOrganization: PartnerOrganization.AETNA,
    campaignSeries: CampaignSeries.AETNA_ILLINOIS_MEDICAID_PEDIATRIC_INITIAL_ENGAGEMENT,
    campaignChannel: CampaignChannel.OMNICHANNEL,
    campaignGroup: CampaignGroupName.INITIAL_ENGAGEMENT,
    campaignType: CampaignType.OUTREACH,
    campaignDisplayName: 'Aetna Illinois Medicaid (Pediatric) 2025',
    campaignAgeCategoryForFive9Routing: CampaignAgeCategory.PEDIATRIC,
    start: DateTime.fromISO('2025-03-01'),
    end: DateTime.fromISO('2025-12-31'),
    population: PatientPopulation.MEDICAID,
    measurementYear: 2025,
    isActive: true as const,
    isCampaignEligibleForReactivation: true,
    shouldEligiblePatientsTrickle: false,
    shouldStalePatientsTrickle: false,
    shouldStale2PatientsTrickle: false,
    shouldStale3PatientsTrickle: false,
    shouldStale4PatientsTrickle: false,
    shouldStale5PatientsTrickle: false,
    shouldStale6PatientsTrickle: false,
    shouldStale7PatientsTrickle: false,
    shouldStale8PatientsTrickle: false,
    shouldStale9PatientsTrickle: false,
    shouldUseCaregiverNameInOutreachContent: true,
    shouldSendMissedCallSMS: false,
    shouldContactEnrichedPhones: false,
    shouldGenerateEngagementReport: false,
    defaultBrandCode: 'SH-ABH-IL',
    shouldRespectEligibilityEndDate: false,
  },

  /*
   *  ----------------------- COMPLETED CAMPAIGNS ------------------------
   *
   */

  // None yet. Once a campaign has been completed, please move it to this section!
};

export type ActiveCampaignName = {
  [K in keyof typeof CAMPAIGN_CONFIG]: typeof CAMPAIGN_CONFIG[K] extends { isActive: true }
    ? K
    : never;
}[keyof typeof CAMPAIGN_CONFIG];

// TODO(dhruv) This function will be updated to return Active campaigns in a followup PR
// Draft PR: https://github.com/Pulsetera/core/pull/4964/files
export default function getCampaignConfig(campaignName: CampaignName): CampaignConfig | null {
  const campaignConfig = CAMPAIGN_CONFIG[campaignName];

  // TODO(86ay9qy8j) Remove this isActive flag
  if (campaignConfig?.isActive) return campaignConfig;

  return null;
}

export function getActiveCampaignNamesByCampaignGroup(
  campaignGroup: CampaignGroupName,
): CampaignName[] {
  const activeCampaignNames = Object.entries(CAMPAIGN_CONFIG)
    .filter(([, campaignConfig]) => {
      if (campaignConfig.isActive && campaignConfig.campaignGroup === campaignGroup) return true;
      return false;
    })
    .map(([campaignName]) => campaignName as CampaignName);

  return activeCampaignNames ?? [];
}

export function getCampaignNamesByCampaignSeries(campaignSeries: CampaignSeries): CampaignName[] {
  const campaignNames = Object.entries(CAMPAIGN_CONFIG)
    .filter(([, campaignConfig]) => campaignConfig.campaignSeries === campaignSeries)
    .map(([campaignName]) => campaignName as CampaignName);

  return campaignNames;
}

export function getCampaignConfigsByCampaignSeries(
  campaignSeries: CampaignSeries,
): { [key in CampaignName]?: CampaignConfig } {
  return Object.entries(CAMPAIGN_CONFIG).reduce((acc, [campaignName, campaignConfig]) => {
    if (campaignConfig.campaignSeries === campaignSeries) {
      acc[campaignName as CampaignName] = campaignConfig;
    }
    return acc;
  }, {} as { [key in CampaignName]?: CampaignConfig });
}

export function getCampaignConfigsByPartnerOrganization(
  partnerOrganization: PartnerOrganization,
): { [key in CampaignName]?: CampaignConfig } {
  const campaignConfigs: { [key in CampaignName]?: CampaignConfig } = {};

  Object.entries(CAMPAIGN_CONFIG).forEach(([campaignName, campaignConfig]) => {
    if (campaignConfig.partnerOrganization !== partnerOrganization) return;
    campaignConfigs[campaignName as CampaignName] = campaignConfig;
  });

  return campaignConfigs;
}
